module.exports = __webpack_public_path__ + "assets/img/icon-logo.d7bb894c.png";